<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates15">
<p class="centerImage"><img alt="images" id="plate15" src="images/plate15.jpg"/></p>
<p class="caption">Pilot Officer Witold Glowaki, from Poland. Crash-landing in France on 24 September, he looks dejected with his head bandaged. Taken to hospital he died that same night, presumably reacting to an anti-tetanus injection. Note the 605 Squadron insignia on the tail-fin (P3832 UP-P). <em class="italic">(Andy Thomas)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates15.vue?ed6372e2